import {
  SEARCH_SYNTAX_QUOTES,
  SEARCH_SYNTAX_WRONG_EXTENSION,
  SEARCH_SYNTAX_WRONG_OPERATORS,
} from 'src/constants/search';

export function extractTerms(query: string): string {
  return query ? query.replace(/([\w-]+:[^\s]+\s?)/g, '') : '';
}

export function matchWrongSyntax(
  query?: string
): 'EXTENSION' | 'OPERATOR' | null {
  const queryWithoutQuotes = query && query.replace(SEARCH_SYNTAX_QUOTES, '');
  if (
    queryWithoutQuotes &&
    queryWithoutQuotes.match(SEARCH_SYNTAX_WRONG_EXTENSION)
  ) {
    return 'EXTENSION';
  } else if (
    queryWithoutQuotes &&
    queryWithoutQuotes.match(SEARCH_SYNTAX_WRONG_OPERATORS)
  ) {
    return 'OPERATOR';
  }
  return null;
}
